<template>
  <div>
    <h2>Đăng nhập bằng số điện thoại</h2>

    <p class="text-justify">Kho bài thi đánh giá năng lực tiếng Trung chất lượng hàng đầu cho tất cả các trình độ HSK 1, HSK 2, HSK 3, HSK 4, HSK 5, HSK 6. Tất cả các câu hỏi trong đề thi đều được biên soạn bởi các giáo viên có nhiều năm kinh nghiệm, đề thi được xây dựng dựa trên ma trận đề thi thật.</p>

    <b-alert show="10" v-model="showErrors" variant="danger" dismissible>
      Vui lòng kiểm tra lại tên đăng nhập / mật khẩu!
    </b-alert>

    <b-form @submit="onSubmit" @reset="onReset" v-if="show" class="auth__form">
      <b-input-group
        id="input-number-phone"
        label="Số điện thoại:"
        label-for="number-phone"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="phone" />
        </b-input-group-append>
        <b-form-input
          id="number-phone"
          v-model="form.phone"
          type="text"
          required
          placeholder="Số điện thoại của bạn"
          class="auth__form__input"
        ></b-form-input>
      </b-input-group>

      <b-input-group
        id="input-password"
        label="Mật khẩu:"
        label-for="password"
      >
        <b-input-group-append class="auth__form__icon">
          <fa-icon icon="lock" />
        </b-input-group-append>
        <b-form-input
          id="password"
          v-model="form.password"
          :type="isHiddenPassword ? 'password' : 'text'"
          required
          placeholder="Mật khẩu của bạn"
          class="auth__form__input"
        ></b-form-input>
        <b-input-group-append 
          class="auth__form__icon"
          @click="isHiddenPassword = !isHiddenPassword">
          <fa-icon :icon="isHiddenPassword ? 'eye' : 'eye-slash' " />
        </b-input-group-append>
      </b-input-group>

      <b-button type="submit" class="auth__form__btn">Đăng nhập</b-button>

      <p>Bạn chưa có tài khoản? Hãy <router-link :to="{ name: 'auth-register', query: nextUrl ? { nextUrl } : {} }">Đăng ký</router-link></p>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        phone: '',
        password: ''
      },
      nextUrl: '',
      show: true,
      isHiddenPassword: true,
      showErrors: false
    }
  },
  computed: {
    ...mapState('auth', ['isLoggedIn', 'error'])
  },
  watch: {
    error(value) {
      if(value != null) {
        this.showErrors = true;
      }
    }
  },
  created() {
    this.nextUrl = this.$route.query.nextUrl || this.$route.query.redirect || '';
  },
  methods: {
    ...mapActions(`auth`, ['authMobiedu', 'clearData']),
    onSubmit(evt) {
      evt.preventDefault()
      this.authMobiedu({ ...this.form, nextUrl: this.nextUrl })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.phone = ''
      this.form.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
    }
  },
  beforeDestroy() {
    this.clearData()
  }
}
</script>